import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "count"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasEditorTarget || !this.hasCountTarget) return
    const text = this.editorTarget.editor?.getDocument().toString().trim() || ""
    const words = text ? text.split(/\s+/).length : 0

    this.countTarget.textContent = `${words}/${this.maxValue}`

    if (words > this.maxValue) {
      this.countTarget.classList.remove("text-gray-500", "text-amber-600")
      this.countTarget.classList.add("text-red-600")
    } else if (words > this.maxValue * 0.9) {
      this.countTarget.classList.remove("text-gray-500", "text-red-600")
      this.countTarget.classList.add("text-amber-600")
    } else {
      this.countTarget.classList.remove("text-amber-600", "text-red-600")
      this.countTarget.classList.add("text-gray-500")
    }
  }
}
